/** Reads the file picked in a file input and clears the input, so picking the same file again fires a change. */
export function takeChosenFile(fileInput: HTMLInputElement): { file: File; isDocx: boolean } | null {
  const [file] = fileInput.files ?? [];

  fileInput.value = '';

  return file ? { file, isDocx: file.name.toLowerCase().endsWith('.docx') } : null;
}
